import type { FeatureGateSeed } from './feature-gate-registry';

/**
 * The knowledge gates, spread into FEATURE_GATE_SEEDS in feature-gate-registry.ts at their place
 * in its order. Knowledge Spaces: ADR 0091, rollout in docs/runbooks/knowledge-spaces-rollout.md;
 * the database seeds each row (Knowledge Spaces: 20261007151426_knowledge_spaces_access.sql; website
 * connectors: 20261030120745_knowledge_web_connectors_gate.sql), and each
 * entry gives the platform's Feature Gates list its label. None is a sidebar item.
 */
export const KNOWLEDGE_FEATURE_GATE_SEEDS = {
  document_comments: {
    label: 'Document comments',
    shortLabel: 'Doc comments',
    description:
      'Comment threads on authored knowledge documents: replies, @mentions, reactions and resolving. Not a sidebar item — gates the Comments tab in the document sidebar; the comment functions refuse every office while the gate is off.',
    group: 'knowledge',
  },
  knowledge_spaces: {
    label: 'Knowledge Spaces',
    shortLabel: 'Spaces',
    description:
      'Team and client spaces in the Knowledge Library, and searches and drafts that use only the material a work item’s client may use. Not a sidebar item - off means the office cannot create spaces or place documents, and its searches and drafts use office material as before; placements already made stay in force.',
    group: 'knowledge',
  },
  knowledge_web_connectors: {
    label: 'Website connectors',
    shortLabel: 'Websites',
    description:
      'Websites an office follows in its Knowledge Spaces: checked on a schedule, new and changed pages added to the Space. Not a sidebar item - off means no website is checked or ingested for the office; pausing and removing stay available.',
    group: 'knowledge',
  },
} satisfies Record<string, FeatureGateSeed>;
